<template>
  <div class="ly_modal_container" :style="{zIndex}">
    <div class="ly_modal_header" @mousedown="dragStart">
      <h1 class="title">소식톡톡 일반소식 수정</h1>
    </div>
    <div class="ly_modal_content" style="min-height: 472px; min-width: 837px">
      <div v-if="newsData" class="table_wrapper">
        <table class="table_view" style="width: 800px">
          <caption>
            <span class="blind">소식톡톡 일반소식 수정</span>
          </caption>
          <colgroup>
            <col width="120" />
            <col />
          </colgroup>
          <tbody class="table_view_body">
            <TargetViewer
              :rcpGroupSendYn="newsData.rcpGroupSendYn"
              :rcpDesc="newsData.rcpDesc"
              @clickRcpListView="onClickRcpListView"
              ref="targetSelector"
            />
            <TitleInput :boardTitle.sync="newsData.boardTitle" :required="true" ref="titleInput" />
            <ContentInput :boardContent.sync="newsData.boardContent" :required="true" ref="contentInput" />
            <SnoozeViewer :snoozeMax="newsData.snoozeMax" :snoozeInterval="newsData.snoozeInterval" />
            <SendTimeSelector
              v-if="isReadyStatus"
              :pushType.sync="newsData.pushType"
              :reserveDate.sync="newsData.reserveDate"
              :required="true"
              ref="sendTimeSelector"
            />
            <SendTimeViewer v-else :pushFirstDate="newsData.pushFirstDate" />
          </tbody>
        </table>
        <p v-if="newsData.pushFirstDate" class="table_data_desc">
          <span class="dot">*</span> 메시지를 수정해도 알림은 다시 보내지 않습니다. 알림을 보내시려면, 받는사람 목록보기에서 재전송 해
          주세요.
        </p>

        <div class="btn_area">
          <button type="button" class="btn_active" @click="submit">수정</button>
          <button type="button" class="btn_default" @click="close">닫기</button>
        </div>
      </div>
    </div>

    <button type="button" @click.prevent="close" class="ly_modal_close">
      <span class="ico">팝업 닫기</span>
    </button>
  </div>
</template>

<script>
import popupMixin from '$mixins/popup';
import newsMixin from '$views/News/_mixin';
import newsRegisterMixin, {defaultData} from './mixins/register';

import TargetViewer from './inputs/TargetViewer';
import TitleInput from './inputs/TitleInput';
import ContentInput from './inputs/ContentInput';
import SnoozeViewer from './inputs/SnoozeViewer';
import SendTimeSelector from './inputs/SendTimeSelector';
import SendTimeViewer from './inputs/SendTimeViewer';

export default {
  mixins: [popupMixin, newsMixin, newsRegisterMixin],
  components: {
    TargetViewer,
    TitleInput,
    ContentInput,
    SnoozeViewer,
    SendTimeSelector,
    SendTimeViewer,
  },
  props: {
    newsId: [String, Number],
    onSubmit: Function,
  },
  data() {
    return {
      selectedRcpList: [],
      newsData: null,
    };
  },
  methods: {
    submit() {
      if (!this.validate()) {
        return false;
      }
      const params = {
        newsType: 'NEWS',
        boardTitle: this.newsData.boardTitle,
        boardContent: this.newsData.boardContent,
        rcpGroupSendYn: this.newsData.rcpGroupSendYn,
      };

      if (this.isReadyStatus) {
        params.pushType = this.newsData.pushType;
        if (params.pushType === 'RESERVE') {
          params.reserveDate = this.$utils.timeText(this.newsData.reserveDate, true);
        }
      }
      const messages = this.getSubmitMessagesGeneral();
      confirm(messages.confirm).then(() => {
        this.$axios.put(`/admin/v2/news/general/${this.newsId}`, params).then(() => this.onSubmitData(messages.complete));
      });
    },
    onSubmitData(msg) {
      alert(msg);
      if (this.onSubmit) {
        this.onSubmit();
      }
      this.close();
    },
    validate() {
      if (!this.$refs.titleInput.validate() || !this.$refs.contentInput.validate()) {
        return false;
      }

      if (this.isReadyStatus && !this.$refs.sendTimeSelector.validate()) {
        return false;
      }

      return true;
    },
    onClickRcpListView() {
      this.openGeneralRecipientList({newsId: this.newsId});
    },
  },
  mounted() {
    this.$axios.get(`/admin/happy/news/${this.newsId}/detail`).then(({data}) => {
      this.newsData = _.merge({}, defaultData, data.data);
      this.$nextTick(this.moveToCenter);
      // 수정확인 메세지를 위해 rcp list 가져옴
      if (this.newsData.rcpGroupSendYn === 'N') {
        this.$axios(`/admin/happy/news/${this.newsId}/rcp/lists`).then(({data}) => (this.selectedRcpList = data.data));
      }
    });
  },
};
</script>
